package app.properties

class Currency(var id: String? = null,
               var name: String = "",
               var isoCode: String = "",
               var symbol: String = "",
               var value: Float = 0F)